var _ = require('lodash');

(function Module() {
	'use strict';

    mySynch.directive('popupNavMenu', [function () {
            return {
                        restrict: 'E',
                        transclude: false,
                        replace:true,
                        templateUrl: '../partials/directive-templates/popup.nav.menu.view.html',
                        scope: {
                            mainLabel: '<',
                            mainLabelTextColor: '<',
                            submenuItemsJson: '<',
                            herdId: '<',
                            farmId: '<'
                        },
                        link: function (scope, element, attrs) {
                            
                            scope.getRandomArbitrary = function(min, max) {
                                return Math.floor(Math.random() * (max - min) + min);
                            };

                            scope.subMenuId = scope.getRandomArbitrary(0,10000);
                            scope.isOpen = false;

                           
                            scope.submenuItems = [];
                            try{
                                scope.submenuItems = JSON.parse(scope.submenuItemsJson);
                            }catch(e){
                                console.log("There was an error in parsing a submenuItemsJson");
                            }
                            
                            


                        },
                        controller: ["$scope","MySynchFactory",'ViewAuthorizationFactory',
                            function($scope,MSF,viewAuth) {
                               
                                $scope.goToPage = function goToPage(page,herdId,farmId){
                                    MSF.loadPageForFarmId(page,herdId,farmId,true,'user',false,true);
                                };

                                $scope.toggleSubmenItemTooltip = function toggleSubmenItemTooltip(event,submenuItem,show){
                                    submenuItem.showTooltip = show;
                                    event.stopPropagation();
                                   };
                                $scope.checkRolePermission = function checkRolePermission(requiredPermission){
                                    return !requiredPermission || viewAuth.hasPermission(requiredPermission);
                                };
                               

                                $scope.$on("$destroy", function() {
			
                                   

                                    
                                 });


                            }
                        ]
                    };

    }]);
})();